import styled from 'styled-components';

export const Wrapper = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.32);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Modal = styled.div`
  margin: 16px;
  width: 512px;
  height: 376px;
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  > div.info {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    max-width: 336px;
    > p {
      margin-top: 0;
    }
  }
`;
